import { render, staticRenderFns } from "./TagesordnungList.vue?vue&type=template&id=c7e67988"
import script from "./TagesordnungList.vue?vue&type=script&lang=js"
export * from "./TagesordnungList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports